import { useState } from 'react';

import cookieStorage, { CookieStorage } from '../CookieStorage';
import { EventBusEvent } from '../enums/EventBus';
import { useSubscriptionCallback } from '../hooks/subscription';
import { CartUpdateStatus } from '../types/Cart';
import type { CartUpdateState } from '../types/Cart';

export const WishlistSubscription = ({ initialValue, children }) => {
  const [count, setCount] = useState(() =>
    typeof initialValue === 'number' ? initialValue : cookieStorage.getWishlistCount()
  );

  useSubscriptionCallback<{ wishlistItemsCount: number }>(
    EventBusEvent.WishlistCounterUpdate,
    ({ wishlistItemsCount }) => {
      setCount(wishlistItemsCount);
      CookieStorage.normalizeNumber(wishlistItemsCount);
    },
    { latestEmitted: true }
  );

  return children({ value: count });
};

export const CartSubscription = ({ initialValue, children }) => {
  const [count, setCount] = useState(() =>
    typeof initialValue === 'number' ? initialValue : cookieStorage.getCartCount()
  );

  useSubscriptionCallback<CartUpdateState>(EventBusEvent.CartUpdate, data => {
    if (data.status === CartUpdateStatus.Success && data.transformed === false) {
      setCount(data.cart.totalItems);
    }
  });

  useSubscriptionCallback<number>(EventBusEvent.CartCounterUpdate, setCount, {
    latestEmitted: true,
  });

  return children({ value: count });
};

export const UserAccountSubscription = ({ initialValue, children }) => {
  const [value, setValue] = useState(initialValue);

  useSubscriptionCallback(EventBusEvent.UserAccountUpdate, setValue, { latestEmitted: true });

  return children({ value });
};
